import type { ReactNode } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Fab, Tooltip } from "@mui/material";
import type { FabProps } from "@mui/material/Fab";
import type { SxProps, Theme } from "@mui/material/styles";

interface FloatingActionButtonProps {
    label: string;
    onClick: () => void;
    icon?: ReactNode;
    color?: FabProps["color"];
    sx?: SxProps<Theme>;
    disabled?: boolean;
}

export default function FloatingActionButton({
    label,
    onClick,
    icon = <AddIcon />,
    color = "primary",
    sx,
    disabled = false,
}: FloatingActionButtonProps) {
    return (
        <Tooltip title={label}>
            <span>
                <Fab
                    variant="extended"
                    color={color}
                    onClick={onClick}
                    aria-label={label}
                    disabled={disabled}
                    sx={[
                        {
                            position: "fixed",
                            right: { xs: 16, sm: 24 },
                            bottom: {
                                xs: "calc(env(safe-area-inset-bottom, 0px) + 104px)",
                                md: "calc(env(safe-area-inset-bottom, 0px) + 24px)",
                            },
                            zIndex: (theme) => theme.zIndex.speedDial,
                            minHeight: 56,
                            px: { xs: 2, sm: 2.5 },
                            borderRadius: 999,
                            gap: 1,
                            whiteSpace: "nowrap",
                            boxShadow: 8,
                        },
                        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
                    ]}
                >
                    {icon}
                    {label}
                </Fab>
            </span>
        </Tooltip>
    );
}
